import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon, Analytics as AnalyticsIcon } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

function BookListHeader({ onAddNewBook, onGoToInsights }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ 
      bgcolor: 'background.paper', 
      borderBottom: 1, 
      borderColor: 'divider',
      py: 3,
      px: 2
    }}>
      <Box sx={{ 
        maxWidth: 'lg', 
        mx: 'auto', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center' 
      }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          {t('collection.title') || 'My Book Collection'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<AnalyticsIcon />}
            onClick={onGoToInsights}
          >
            {t('common.insights') || 'Insights'}
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAddNewBook}
          >
            {t('collection.addBook') || 'Add Book'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default BookListHeader; 